<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>basic data</el-breadcrumb-item>
      <el-breadcrumb-item>Invitation Code</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <collapse @getDataList="search" :button-text="'search'">
        <collapse-item>
          <span class="createTime">Create Time:</span>
          <el-date-picker
            @change="dateChange"
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="start Date"
            format="yyyy-MM-dd"
            end-placeholder="end Date"
            :picker-options="pickerOptions"
          >></el-date-picker>
        </collapse-item>
        <collapse-item>
          <span class="Status：">Status：</span>
          <el-select v-model="queryInfoparams.params.status" placeholder="plase choose"  clearable @clear="queryInfoparams.params.status==null">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </collapse-item>
      </collapse>
      <!-- <collapse></collapse> -->
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button plain size="small" icon="el-icon-plus" v-hasPermission="['InvitationCode:add']"  @click="addDialogVisible = true">add</el-button>
            <el-button plain size="small" icon="el-icon-download" v-hasPermission="['InvitationCode:excel']" @click="exportData">export</el-button>
            <!-- <el-button plain size="small" icon="el-icon-delete" @click="reset">reset</el-button> -->
          </el-button-group>
        </el-col>
      </el-row>
      <el-table :data="dataList" border stripe>
        <el-table-column type="index" label="No."></el-table-column>
        <!-- <el-table-column label="Agency Name" sortable prop="agencyName"></el-table-column> -->
        <el-table-column label="Company Name" sortable prop="companyName"></el-table-column>
        <el-table-column label="Invitation Code" sortable prop="invitationCode"></el-table-column>
        <el-table-column label="Used" sortable prop="status">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'">unused</el-tag>
            <el-tag v-else-if="scope.row.status==='1'">used</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Register Name" sortable prop="registerPersonName"></el-table-column>
        <el-table-column label="Register Email" sortable prop="registerEmail"></el-table-column>
        <el-table-column label="Register Time" sortable prop="registerDate"></el-table-column>
        <el-table-column label="Company Type" sortable prop="companyType">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.companyType==='0'">Plumber Company</el-tag>
            <el-tag v-else-if="scope.row.companyType==='1'">Plumber</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Created Time" sortable prop="createdTime"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog
      title="Please Enter"
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
        <el-form-item label="InvitationCodeNumber:" label-width="180px" prop="codeNumber">
          <el-input v-model="addForm.codeNumber" type="number" @change="codeChange"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="addData">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from '@/services/localstorage'
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'Last three months',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      options: [
        {
          value: '',
          label: '',
        },
        {
          value: '1',
          label: 'used',
        },
        {
          value: '0',
          label: 'unused',
        },
      ],
      value: '',
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      dataList: [],
      addForm: {
        userType: '',
        companyId: '',
        userId: '',
        codeNumber: '',
      },
      // 添加表单的验证规则对象

      addFormRules: {
        codeNumber: [
            { required: true, message: 'Invitation code number is required', trigger: 'blur' }
          ],
        },
      total: 0,
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,

      dateRange: '',
    }
  },

  created() {
    var user = db.get('user')
    console.log('user数据userId' + this.addForm.userId)
    this.addForm.userId = user.userId
    this.addForm.userType = user.userType
    this.addForm.companyId = user.companyId
  },
  methods: {
     codeChange(){
      debugger
      if(this.addForm.codeNumber>1000){
         this.addForm.codeNumber="";

        return this.$message.error('The quantity of invitation code cannot exceed (1000).')
      }
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询数据列表
    async getDataList() {
      // console.log(this.queryInfoparams)
      this.$post(
        'InvitationCode/pageQuery',
        JSON.stringify(this.queryInfoparams)
      ).then(({ data: res }) => {
        this.dataList = res.records
        this.total = res.total
      })
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addDialogVisible = false
      this.$refs.addFormRef.resetFields()
    },
    dateChange(value) {
      console.log(value)
      if (value != null && value != undefined) {
        this.queryInfoparams.params.startCreatedTime = value[0]
        this.queryInfoparams.params.endCreatedTime = value[1]
      } else {
        this.queryInfoparams.params.startCreatedTime = null
        this.queryInfoparams.params.endCreatedTime = null
      }
    },
    // 点击按钮 添加
    async addData() {
      console.log('addForm:' + this.addForm.codeNumber)
      console.log('addFormuserID:' + this.addForm.userId)

      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
         const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        this.$get('InvitationCode/add/'+this.addForm.codeNumber).then(({ data: res }) => {
          loading.close()
          if (res.ok) {
            // 隐藏添加的对话框
            this.addDialogVisible = false
            // 刷新列表数据
            this.search()
            this.addDialogClosed()

            return this.$message.success('successfully')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

    // 点击按钮 添加
    async exportData() {
      console.log('queryInfoparams:' + this.queryInfoparams.params.userType)
      // addForm.userId=db.get("userId")
      let res = this.$export(
        'InvitationCode/export',
        JSON.stringify(this.queryInfoparams),
        'InvitationCode'
      )
    },
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510 {
  height: auto;
}
.el-col {
  display: flex;
}
</style>